import { delay } from "common/promises";
import { html, LitElement } from "lit-element";
import { classMap } from "lit-html/directives/class-map";
import { styleMap } from "lit-html/directives/style-map";
export class CameraFlash extends LitElement {
    constructor() {
        super(...arguments);
        this.show = false;
        this.opacituFull = false;
    }
    // trigger animation
    createRenderRoot() {
        return this;
    }
    async trigger() {
        this.opacituFull = true;
        this.requestUpdate();
        await delay(100);
        this.show = true;
        this.requestUpdate();
        await delay(100);
        this.opacituFull = false;
        this.requestUpdate();
        await delay(500);
        this.show = false;
        this.opacituFull = false;
        this.requestUpdate();
    }
    render() {
        const klass = {
            dn: !this.show,
            "o-0": !this.opacituFull,
        };
        const style = {
            transition: "0.4s opacity linear",
        };
        return html `<div
      class="absolute absolute--fill bg-white ${classMap(klass)}"
      style="${styleMap(style)}"
    >
      <jh-render-debug name="camera-flash"></jh-render-debug>
    </div>`;
    }
}
customElements.define("jh-camera-flash", CameraFlash);
//# sourceMappingURL=cameraFlash.js.map